import {
  connectionHasActiveInvestmentAccount,
  connectionHasActiveNonInvestmentAccount,
  fetchManualConnections,
  fetchPlaidConnections,
  filterActiveFinancialConnections,
  logConnectionAccountStatuses,
  type MemberPlaidApiClient,
} from "./memberPlaidApi";
import type { FinancialConnection } from "@features/api/memberApi";

export const PORTFOLIO_CONNECTIONS_QUERY_KEY = [
  "portfolio-financial-connections",
] as const;

export interface PortfolioConnectionsCache {
  manualConnections: FinancialConnection[];
  investConnections: FinancialConnection[];
  nonInvestConnections: FinancialConnection[];
  plaidConnections: FinancialConnection[];
  plaidManualConnections: FinancialConnection[];
}

export const fetchPortfolioConnectionsQueryData = async (
  memberApi: MemberPlaidApiClient,
): Promise<PortfolioConnectionsCache> => {
  const [plaidRaw, manualRaw] = await Promise.all([
    fetchPlaidConnections(memberApi),
    fetchManualConnections(memberApi),
  ]);

  plaidRaw.forEach((conn) => logConnectionAccountStatuses(conn, "PLAID"));
  manualRaw.forEach((conn) => logConnectionAccountStatuses(conn, "MANUAL"));

  const plaidActive = filterActiveFinancialConnections(plaidRaw);
  const manualActive = filterActiveFinancialConnections(manualRaw);
  const plaidInvest = plaidActive.filter(connectionHasActiveInvestmentAccount);
  const manualInvest = manualActive.filter(
    connectionHasActiveInvestmentAccount,
  );
  const allActive = [...plaidActive, ...manualActive];

  return {
    manualConnections: manualActive,
    investConnections: [...plaidInvest, ...manualInvest],
    nonInvestConnections: allActive.filter(
      connectionHasActiveNonInvestmentAccount,
    ),
    plaidConnections: plaidInvest,
    plaidManualConnections: manualInvest,
  };
};
